import { Label } from "components/atoms";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
  PiArrowClockwiseBold,
  PiArrowsClockwiseBold,
  PiNotepad,
  PiSeal,
  PiSealCheck,
  PiSealQuestion,
  PiSealWarning,
  PiXCircleFill,
} from "react-icons/pi";
import { STATUS } from "services/types";
import { IColorProp } from "types/components/components.interface";
import LabeledContractStatus from "./LabeledContractStatus";
import "./LabeledStatus.scss";
import { LABEL_STATUS } from "services/labels/types";

export interface ILabeledStatusProps<T = LABEL_STATUS> {
  status: T;
  noname?: boolean;
}

export interface ILabeledStatusParams<T = LABEL_STATUS> extends IColorProp {
  status: T;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: LABEL_STATUS.unknown,
    color: "gray",
    icon: <PiSealQuestion />,
  },
  {
    status: LABEL_STATUS.draft,
    color: "black",
    icon: <PiNotepad />,
  },
  {
    status: LABEL_STATUS.verified,
    color: "green",
    icon: <PiSealCheck />,
  },
  {
    status: LABEL_STATUS.notVerified,
    color: "red",
    icon: <PiXCircleFill />,
  },
  {
    status: LABEL_STATUS.duringVerification,
    color: "blue",
    icon: <PiArrowsClockwiseBold className="rotating-icon" />,
  },
  {
    status: LABEL_STATUS.banned,
    color: "red",
    icon: <PiXCircleFill />,
  },
];

const LabeledLabelStatus = ({ status, noname }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find((params) => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      style={{ width: "100%" }}
      size="compact"
      color={labeledParams.color}
      title={t(`enum.LABEL_STATUS.${LABEL_STATUS[labeledParams.status]}`)}
      className={`global-label-status ${LABEL_STATUS[labeledParams.status]}`}
    >
      {labeledParams.icon}{" "}
      {!noname && t(`enum.LABEL_STATUS.${LABEL_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledLabelStatus;
